<div class="task-based-labor-container" [formGroup]="taskBasedLaborForm">
    <div class="row">
        <label>{{'PROPERTIES_TASK_BASED_LABOR_LABEL' | translate}}</label>
    </div>
    <fieldset>
        <legend>{{'PROPERTIES_TASK_BASED_LABOR_MISCELLANEOUS' | translate}}</legend>
        <div class="row">
            <div class="col-sm-4">
                <label>{{'PROPERTIES_TASK_BASED_LABOR_FIRE_ALARM' | translate}}</label>
            </div>
            <div class="col-sm-4">
                <label>{{'PROPERTIES_TASK_BASED_LABOR_FIRE_SPRINKLER_DESIGN' | translate}}</label>
            </div>
            <div class="col-sm-4"></div>
        </div>
        <div class="row">
            <div class="col-sm-4">
                <div class="col-sm-1">
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="relevantDesignPages" type="number">
                    </mat-form-field>
                </div>
                <div class="col-sm-10">
                    <label>{{'PROPERTIES_TASK_BASED_LABOR_RELEVANT_DESIGN_PAGES' | translate}}</label>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="col-sm-1">
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="designPagesBuiltDesign" type="number">
                    </mat-form-field>
                </div>
                <div class="col-sm-10">
                    <label>{{'PROPERTIES_TASK_BASED_LABOR_DESIGN_PAGES_BUILT_DESIGN' | translate}}</label>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="col-sm-1">
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="pumpsElectric" type="number">
                    </mat-form-field>
                </div>
                <div class="col-sm-10">
                    <label>{{'PROPERTIES_TASK_BASED_LABOR_PUMPS_ELECTRIC' | translate}}</label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4">
                <mat-checkbox color="primary" formControlName="fireAlarm">{{'PROPERTIES_TASK_BASED_LABOR_FIRE_ALARM_CHECKBOX' | translate}}</mat-checkbox>
            </div>
            <div class="col-sm-4">
                <div class="col-sm-1">
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="sprinklerHeads" type="number">
                    </mat-form-field>
                </div>
                <div class="col-sm-10">
                    <label>{{'PROPERTIES_TASK_BASED_LABOR_SPRINKLER_HEADS' | translate}}</label>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="col-sm-1">
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="pumpsDiesel" type="number">
                    </mat-form-field>
                </div>
                <div class="col-sm-10">
                    <label>{{'PROPERTIES_TASK_BASED_LABOR_PUMPS_DIESEL' | translate}}</label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4"></div>
            <div class="col-sm-6">
                <div class="col-sm-1">
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="numOfDifferentHazards" type="number">
                    </mat-form-field>
                </div>
                <div class="col-sm-10">
                    <label>{{'PROPERTIES_TASK_BASED_LABOR_NUM_DIFFERENT_HAZARDS' | translate}}</label>
                </div>
            </div>

        </div>
        <div class="row">
            <div class="col-sm-4"></div>
            <div class="col-sm-4">
                <mat-checkbox color="primary" formControlName="bimCoordination">{{'PROPERTIES_TASK_BASED_LABOR_BIM_COORDINATION' | translate}}</mat-checkbox>
            </div>
            <div class="col-sm-4"></div>
        </div>
        <div class="row">
            <div class="col-sm-4"></div>
            <div class="col-sm-4">
                <button mat-raised-button color="primary" (click)="openJobDetails()" [disabled]="taskBasedLaborForm.disabled">{{'PROPERTIES_TASK_BASED_LABOR_JOB_DETAILS_BUTTON' | translate}}</button>
            </div>
            <div class="col-sm-4"></div>
        </div>
        <hr>
        <div class="row">
            <mat-checkbox color="primary" formControlName="engineeringComplete">{{'PROPERTIES_TASK_BASED_LABOR_ENGINEERING_COMPLETE' | translate}}</mat-checkbox>
        </div>
        <div class="row">
            <mat-checkbox color="primary" formControlName="peStampsRequired">{{'PROPERTIES_TASK_BASED_LABOR_PE_STAMPS_REQUIRED' | translate}}</mat-checkbox>
        </div>
        <div class="row">
            <mat-checkbox color="primary" formControlName="preTestExistingDevicesCheckbox" class="col-sm-6">{{'PROPERTIES_TASK_BASED_LABOR_PRE_TEST_EXISTING_DEVICES' | translate}}</mat-checkbox>
            <div class="col-sm-4">
                <div class="col-sm-3">
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="preTestExistingDevices" type="number">
                    </mat-form-field>
                </div>
                <div class="col-sm-6">
                    <label>{{'PROPERTIES_TASK_BASED_LABOR_DEVICES' | translate}}</label>
                </div>
            </div>
        </div>
        <div class="row">
            <mat-checkbox color="primary" formControlName="printingSubmittalAssemblyCheckbox" class="col-sm-6">{{'PROPERTIES_TASK_BASED_LABOR_PRINTING_SUBMITTAL_ASSEMBLY' | translate}}</mat-checkbox>
            <div class="col-sm-4">
                <div class="col-sm-3">
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="printingSubmittalAssembly" type="number">
                    </mat-form-field>
                </div>
                <div class="col-sm-6">
                    <label>{{'PROPERTIES_TASK_BASED_LABOR_BOOKLETS' | translate}}</label>
                </div>
            </div>
        </div>
        <div class="row">
            <mat-checkbox color="primary" formControlName="intelligibilityDesignAreasCheckbox" class="col-sm-6">{{'PROPERTIES_TASK_BASED_LABOR_INTELLIGIBILITY_DESIGN_AREAS' | translate}}</mat-checkbox>
            <div class="col-sm-4">
                <div class="col-sm-3">
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="intelligibilityDesignAreas" type="number">
                    </mat-form-field>
                </div>
                <div class="col-sm-6">
                    <label>{{'PROPERTIES_TASK_BASED_LABOR_ADS' | translate}}</label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
            <div class="col-sm-3">
                <mat-form-field appearance="outline" class="full-width">
                    <input matInput formControlName="gridLayouts"/>
                </mat-form-field>
            </div>
            <div class="col-sm-4">
                <label>{{'PROPERTIES_TASK_BASED_LABOR_ERCES_GRID_LAYOUTS' | translate}}</label>
            </div>
            </div>
            <div class="col-sm-6">
            <div class="col-sm-3">
                <mat-form-field appearance="outline" class="full-width">
                    <input matInput formControlName="areaRefugeStations"/>
                </mat-form-field>
            </div>
            <div class="col-sm-4">
                <label>{{'PROPERTIES_TASK_BASED_LABOR_AREA_REFUGE_STATIONS' | translate}}</label>
            </div>
            </div>
        </div>
    </fieldset>
    <div class="row">
        <div class="col-sm-4">
            <fieldset>
                <legend>{{'PROPERTIES_TASK_BASED_LABOR_STANDARD_FIRE_SYSTEM_TESTS_LEGEND' | translate}}</legend>
                <div class="row">
                    <div class="col-sm-6"></div>
                    <div class="col-sm-3">
                        <label>{{'PROPERTIES_TASK_BASED_LABOR_TESTS' | translate}}</label>
                    </div>
                    <div class="col-sm-3">
                        <label>{{'PROPERTIES_TASK_BASED_LABOR_TESTERS' | translate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <label>{{'PROPERTIES_TASK_BASED_LABOR_PRELIMINARY' | translate}}</label>
                    </div>
                    <div class="col-sm-3">
                        {{preliminaryTests}}
                    </div>
                    <div class="col-sm-3">
                        <mat-form-field appearance="outline" class="full-width col-sm-12">
                            <input matInput formControlName="preliminaryTesters"/>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <label>{{'PROPERTIES_TASK_BASED_LABOR_ACCEPTANCE' | translate}}</label>
                    </div>
                    <div class="col-sm-3">
                        <mat-form-field appearance="outline" class="full-width col-sm-12">
                            <input matInput formControlName="acceptanceTests"/>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-3">
                        <mat-form-field appearance="outline" class="full-width col-sm-12">
                            <input matInput formControlName="acceptanceTesters"/>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <label>{{'PROPERTIES_TASK_BASED_LABOR_VESDA' | translate}}</label>
                    </div>
                    <div class="col-sm-3"></div>
                    <div class="col-sm-3"></div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <label>{{'PROPERTIES_TASK_BASED_LABOR_PRELIMINARY' | translate}}</label>
                    </div>
                    <div class="col-sm-3">
                        {{preliminaryTestsVesda}}
                    </div>
                    <div class="col-sm-3">
                        <mat-form-field appearance="outline" class="full-width col-sm-12">
                            <input matInput formControlName="preliminaryTestersVesda"/>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <label>{{'PROPERTIES_TASK_BASED_LABOR_ACCEPTANCE' | translate}}</label>
                    </div>
                    <div class="col-sm-3">
                         <mat-form-field appearance="outline" class="full-width col-sm-12">
                            <input matInput formControlName="acceptanceTestsVesda"/>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-3">
                        <mat-form-field appearance="outline" class="full-width col-sm-12">
                            <input matInput formControlName="acceptanceTestersVesda"/>
                        </mat-form-field>
                    </div>
                </div>
            </fieldset>
        </div>
        <div class="col-sm-6">
            <fieldset>
                <legend>{{'PROPERTIES_TASK_BASED_LABOR_FIRE_SPRINKLER_SYSTEM_TESTS' | translate}}</legend>
                <div class="row">
                <div class="col-sm-6"></div>
                <div class="col-sm-3">
                    <label>{{'PROPERTIES_TASK_BASED_LABOR_TESTS' | translate}}</label>
                </div>
                <div class="col-sm-3">
                    <label>{{'PROPERTIES_TASK_BASED_LABOR_TESTERS' | translate}}</label>
                </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <label>{{'PROPERTIES_TASK_BASED_LABOR_HYDROSTATIC_TEST' | translate}}</label>
                    </div>
                    <div class="col-sm-3">
                        <mat-form-field appearance="outline" class="full-width col-sm-12">
                            <input matInput formControlName="hydrostaticTests"/>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-3">
                        <mat-form-field appearance="outline" class="full-width col-sm-12">
                            <input matInput formControlName="hydrostaticTesters"/>
                        </mat-form-field>
                    </div>
                </div>
                 <div class="row">
                    <div class="col-sm-6">
                        <label>{{'PROPERTIES_TASK_BASED_LABOR_FIRE_PUMP_ACCEPTANCE_TEST' | translate}}</label>
                    </div>
                    <div class="col-sm-3">
                        <mat-form-field appearance="outline" class="full-width col-sm-12">
                            <input matInput formControlName="firePumpAcceptanceTests"/>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-3">
                        <mat-form-field appearance="outline" class="full-width col-sm-12">
                            <input matInput formControlName="firePumpAcceptanceTesters"/>
                        </mat-form-field>
                    </div>
                </div>
                 <div class="row">
                    <div class="col-sm-6">
                        <label>{{'PROPERTIES_TASK_BASED_LABOR_ACCEPTANCE_PER_SYSTEM' | translate}}</label>
                    </div>
                    <div class="col-sm-3">
                        <mat-form-field appearance="outline" class="full-width col-sm-12">
                            <input matInput formControlName="acceptancePerSystemTests"/>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-3">
                        <mat-form-field appearance="outline" class="full-width col-sm-12">
                            <input matInput formControlName="acceptancePerSystemTesters"/>
                        </mat-form-field>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
</div>